import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { initGTM, type DonationForm } from '@kuow/core';
import { PortalProvider } from './providers/PortalProvider';
import { InitialDataContext } from './context/InitialDataContext';
import App from './App';

declare global {
  interface Window {
    __KUOW_INITIAL_DATA__?: DonationForm;
  }
}

const initialData = window.__KUOW_INITIAL_DATA__ ?? null;

initGTM();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <InitialDataContext.Provider value={initialData}>
          <PortalProvider>
            <App />
          </PortalProvider>
        </InitialDataContext.Provider>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);
